import { avicennaTheme } from "./GlobalStyle";

export const customStyles = {
  container: (styles: any) => ({
    ...styles,
    width: '100%',
    fontFamily: avicennaTheme.fonts.body,
  }),
  control: (styles: any) => ({
    ...styles,
    borderColor: avicennaTheme.colors.primaryLight,
    borderRadius: '8px',
    borderWidth: '2px',

    ':hover': {
      ...styles[':hover'],
      borderColor: avicennaTheme.colors.primaryLight,
    },
  }),
  indicatorSeparator: (styles: any) => ({
    ...styles,
    marginTop: '4px',
    marginBottom: '4px',
    backgroundColor: avicennaTheme.colors.primaryLight,
  }),
  dropdownIndicator: (styles: any) => ({
    ...styles,
    color: avicennaTheme.colors.primaryLight,
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    padding: '6px 8px',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: avicennaTheme.colors.primary,
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: avicennaTheme.colors.primary,
  }),
  option: (styles: any, { isSelected, isFocused }: any) => {
    let backgroundColor: any;

    if (isSelected) {
      backgroundColor = avicennaTheme.colors.primaryLightest;
    } else if (isFocused) {
      backgroundColor = avicennaTheme.colors.primaryLightest;
    } else {
      backgroundColor = null;
    }

    return {
      ...styles,
      whiteSpace: 'pre-wrap',
      lineHeight: '20px',
      backgroundColor,
      color: avicennaTheme.colors.primary,
    };
  },
};